// @flow
import * as PublicPagesConstants from "../../Constants/PublicPages/publicPagesConstants";

type StateType = {
  testimonials: {
    isFetching: boolean,
    hasError: boolean,
    data: Array<Object>
  },
  logos: {
    isFetching: boolean,
    hasError: boolean,
    data: Array<Object>
  }
};

type ActionType = {
  type: string,
  payload: Object
}

const initialState = {
  testimonials: {
    isFetching: false,
    hasError: false,
    data: []
  },
  logos: {
    isFetching: false,
    hasError: false,
    data: []
  }
};

export default function landingpage(state: StateType = initialState, action: ActionType) {
  switch (action.type) {
    case PublicPagesConstants.LANDING_PAGE_TESTIMONIALS_REQUEST:
      return landingPageTestimonialsRequest(state);
    case PublicPagesConstants.LANDING_PAGE_TESTIMONIALS_SUCCESS:
      return landingPageTestimonialsSuccess(state, action);
    case PublicPagesConstants.LANDING_PAGE_TESTIMONIALS_FAILURE:
      return landingPageTestimonialsFailure(state);
    case PublicPagesConstants.LANDING_PAGE_LOGOS_REQUEST:
      return landingPageLogosRequest(state);
    case PublicPagesConstants.LANDING_PAGE_LOGOS_SUCCESS:
      return landingPageLogosSuccess(state, action);
    case PublicPagesConstants.LANDING_PAGE_LOGOS_FAILURE:
      return landingPageLogosFailure(state);
    default:
      return state;
  }
}

function landingPageTestimonialsRequest(state) {
  return {
    ...state,
    testimonials: {
      ...state.testimonials,
      isFetching: true,
      hasError: false,
    }
  };
}

function landingPageTestimonialsSuccess(state, action) {
  const { data }: Object = action.payload;
  return {
    ...state,
    testimonials: {
      ...state.testimonials,
      isFetching: false,
      data: data,
      hasError: false,
    }
  };
}

function landingPageTestimonialsFailure(state) {
  return {
    ...state,
    testimonials: {
      ...state.testimonials,
      isFetching: false,
      data: [],
      hasError: true,
    }
  };
}

function landingPageLogosRequest(state) {
  return {
    ...state,
    logos: {
      ...state.logos,
      isFetching: true,
      hasError: false
    }
  };
}

function landingPageLogosSuccess(state, action) {
  const { data }: Object = action.payload;
  return {
    ...state,
    logos: {
      ...state.logos,
      isFetching: false,
      data: data,
      hasError: false,
    }
  }
}

function landingPageLogosFailure(state) {
  return {
    ...state,
    logos: {
      ...state.logos,
      isFetching: false,
      data: [],
      hasError: true,
    }
  };
}


// WEBPACK FOOTER //
// ./src/Reducers/PublicPages/landingpage.js